import { Routes, Route } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import Login from './components/Login';
import Dashboard from './components/Dashboard';
import PrivateRoute from './components/PrivateRoute';
import MapPage from './components/MapPage';
import ComplaintsView from './components/ComplaintsView';
import ReadingsView from './components/ReadingsView';
import EditProfileView from './components/EditProfileView';
import UsersView from './components/UsersView';
import DevicesView from './components/DevicesView';
import EmissionPointsView from './components/EmissionPointsView';
import IncidentsView from './components/IncidentsView';
import WarningsView from './components/WarningsView';
import ConcentrationsView from './components/ConcentrationsView';

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        >
          <Route index element={<MapPage />} />
          <Route path="map" element={<MapPage />} />
          <Route path="readings" element={<ReadingsView />} />
          <Route path="complaints" element={<ComplaintsView />} />
          <Route path="edit-profile" element={<EditProfileView />} />
          <Route path="users" element={<UsersView />} />
          <Route path="devices" element={<DevicesView />} />
          <Route path="emission-points" element={<EmissionPointsView />} />
          <Route path="incidents" element={<IncidentsView />} />
          <Route path="warnings" element={<WarningsView />} />
          <Route path="concentrations" element={<ConcentrationsView />} />
        </Route>
      </Routes>
    </LocalizationProvider>
  );
}

export default App;
